module.exports = __webpack_public_path__ + "img/unimed-andradas.5b375347.png";